import React from 'react';
import { useQuery } from 'react-query';
import Layout from '../../containers/Layout';
import FilledButton from '../../components/Buttons/FilledButton';
import TierService from '../../services/TierService';
import BillingService from '../../services/BillingService';
import classes from './styles.module.scss';

export default function PricingPage() {
  const { data: tiers, isLoading } = useQuery('tiers-public', TierService.listPublic);

  const handleUpgrade = async (tierId) => {
    try {
      const { data } = await BillingService.createCheckoutSession(tierId);
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error(error?.response?.data?.message || 'Failed to start upgrade');
    }
  };

  return (
    <Layout hasUserBlock>
      <div className={classes.wrapper}>
        <h1 className={classes.title}>Plans</h1>
        {isLoading && <div className={classes.loading}>Loading plans…</div>}
        <div className={classes.cards}>
          {tiers?.data?.map((tier) => (
            <div key={tier.id} className={classes.card}>
              <div className={classes.cardHeader}>
                <h2>{tier.name}</h2>
                {tier.amount != null ? (
                  <div className={classes.price}>
                    ${((tier.amount || 0) / 100).toFixed(0)}
                    <span>/mo</span>
                  </div>
                ) : (
                  <div className={classes.price}>Free</div>
                )}
              </div>
              <p className={classes.description}>{tier.description || 'Includes core features.'}</p>
              <ul className={classes.limits}>
                <li>{tier.seatLimit} users</li>
                <li>{tier.storageLimitMb} MB storage</li>
              </ul>
              {tier.priceId ? (
                <FilledButton
                  onClick={() => handleUpgrade(tier.id)}
                  className={classes.upgradeButton}
                >
                  Upgrade
                </FilledButton>
              ) : (
                <div className={classes.freeLabel}>Current plan</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

